import { Button, Heading, Icon } from "@elaniintc/goes-design-system";
import SearchInput from "../search-input";
import { PulseIndicator } from "../pulse-indicator";

interface Props {
  title: string;
  isLoading?: boolean; // whether the table data is currently being fetched or updated
  search: string | null;
  searchPlaceholder?: string;
  setSearch: (value: string | null) => void;
  canCreate?: boolean;
  createLabel: string;
  onCreate?: () => void;
  onFilter?: () => void;
  filtersApplied: number;
}

const TableHeader = ({
  title,
  search,
  canCreate = false,
  isLoading,
  createLabel,
  searchPlaceholder = "Buscar...",
  setSearch,
  onCreate,
  onFilter,
  filtersApplied = 0,
}: Props) => {
  return (
    <div className="px-3 py-3 w-full flex gap-2 tablet:flex-wrap tablet:gap-0 tablet:items-center justify-between">
      <div className="flex items-center gap-2">
        <Heading variant="h6" data-testid="table-title">
          {title}
        </Heading>
        {isLoading && (
          <Icon
            type="far"
            name="spinner-third"
            className="animate-spin text-on-disabled"
          />
        )}
      </div>
      <div className="flex items-center gap-2">
        <div className="hidden md:inline">
          <SearchInput
            variant="xs"
            placeholder={searchPlaceholder}
            data-testid="search-input"
            className="w-[240px] text-sm"
            value={search || ""}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <Button
          className="md:hidden"
          aria-label="Buscar"
          size="icon"
          variant="quiet"
        >
          <Icon type="far" name="search" className="" />
        </Button>

        <Button
          data-testid="filter-button"
          size="xs"
          variant="quiet"
          type="button"
          onClick={onFilter}
          className="relative"
        >
          <span className="hidden md:inline-block">Filtros</span>
          <Icon type="far" name="filter" className="text-current" />
          <PulseIndicator showIndicator={filtersApplied > 0} />
        </Button>
        {canCreate && (
          <Button size="xs" onClick={onCreate}>
            <span className="hidden md:inline-block">{createLabel}</span>
            <Icon type="far" name="plus" className="text-current" />
          </Button>
        )}
      </div>
    </div>
  );
};

export default TableHeader;
